import { fetchSearchMeta } from 'shared/services/fetchSearchMeta';
import { TAsyncThunkAction } from 'shared/types/redux';
import { prepareJsonQuery } from './utils';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { selectLocation } from 'shared/selectors/location';
import { setSearchMeta, setSearchMetaIsLoading } from 'shared/slices/searchMeta';
import { debounce } from 'throttle-debounce';
import { ISearchMeta } from 'shared/types/searchMeta';

const debouncedFetchSearchMeta = debounce(500, ({ resolver, context, parameters }) =>
  fetchSearchMeta(context, parameters).then(resolver),
);

interface IParams {
  /**
   * Запросить мету сразу, без дебаунса. Нужно там, где обновление не связано с
   * набором фильтров руками и ждать нечего: например, рантайм-апи /v1/set-json-query,
   * которое сразу после меты эмитит `filters:updated`.
   */
  immediate?: boolean;
}

export const updateSearchMeta =
  ({ immediate = false }: IParams = {}): TAsyncThunkAction =>
  async (dispatch, getState, context) => {
    const state = getState();

    const jsonQuery = prepareJsonQuery({ jsonQuery: selectJsonQuery(state), location: selectLocation(state) });

    dispatch(setSearchMetaIsLoading(true));

    const newMeta: ISearchMeta | null = immediate
      ? await fetchSearchMeta(context, { jsonQuery })
      : await new Promise(resolve =>
          debouncedFetchSearchMeta({ resolver: resolve, context, parameters: { jsonQuery } }),
        );

    if (newMeta) {
      dispatch(setSearchMeta(newMeta));
    } else {
      dispatch(setSearchMetaIsLoading(false));
    }
  };
